import React from "react";
import { Link, useLocation } from "react-router-dom";

const PRODUCT_LABELS = {
	"shady-lane": "Shady Lane",
	"secco-chimneys": "Secco Chimneys",
	Fans: "Fans",
	Freestalls: "Freestalls",
	"EXL Lockups": "EXL Lockups",
	"Stainless Steel Tip Tanks": "Stainless Steel Tip Tanks",
	"Auto Vent Controllers": "Auto Vent Controllers",
};

function getCurrentPage(pathname) {
	const match = pathname.match(/^\/products\/(.+)$/);
	if (!match) return null;

	const slug = decodeURIComponent(match[1]);
	return PRODUCT_LABELS[slug] || slug;
}

function CrumbDivider() {
	return (
		<li aria-hidden="true" className="text-gray-300">
			<i className="fa-solid fa-chevron-right text-[10px]"></i>
		</li>
	);
}

function Breadcrumbs() {
	const { pathname } = useLocation();
	const currentPage = getCurrentPage(pathname);

	return (
		<nav aria-label="Breadcrumb" className="min-h-[38px]">
			<ol className="flex flex-wrap items-center gap-2 text-sm">
				<li>
					<Link
						to="/"
						className="text-gray-500 transition hover:text-primary hover:underline"
					>
						Home
					</Link>
				</li>
				<CrumbDivider />
				<li>
					{currentPage ? (
						<Link
							to="/products"
							className="text-gray-500 transition hover:text-primary hover:underline"
						>
							Products
						</Link>
					) : (
						<span
							className="font-semibold text-gray-900"
							aria-current="page"
						>
							Products
						</span>
					)}
				</li>
				{currentPage && (
					<>
						<CrumbDivider />
						<li
							className="font-semibold text-gray-900"
							aria-current="page"
						>
							{currentPage}
						</li>
					</>
				)}
			</ol>
		</nav>
	);
}

export default Breadcrumbs;
